const LEN = { IT: 27, SM: 27, VA: 22, DE: 22, FR: 27, ES: 24, AT: 20, BE: 16, NL: 18, PT: 25, CH: 21, LU: 20, IE: 22, GB: 22, MT: 31, SI: 19, HR: 21 };
const BANKS = { "03069": "Intesa Sanpaolo", "02008": "UniCredit", "05034": "Banco BPM", "01030": "Monte dei Paschi di Siena", "05387": "BPER Banca", "06230": "Crédit Agricole Italia", "03062": "Banca Mediolanum", "03015": "FinecoBank", "07601": "Poste Italiane (BancoPosta)", "01005": "BNL", "03032": "Credem", "03475": "ING", "05696": "Banca Popolare di Sondrio", "03268": "Banca Sella" };
const ODD = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23];
const idx = (c) => (/\d/.test(c) ? Number(c) : c.charCodeAt(0) - 65);

const mod97 = (iban) => {
  const s = (iban.slice(4) + iban.slice(0, 4)).replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));
  let r = 0;
  for (const ch of s) r = (r * 10 + Number(ch)) % 97;
  return r === 1;
};

const cinOk = (bban) => {
  const sum = [...bban.slice(1)].reduce((a, c, i) => a + (i % 2 === 0 ? ODD[idx(c)] : idx(c)), 0);
  return String.fromCharCode(65 + (sum % 26)) === bban[0];
};

export function checkIban(raw) {
  const iban = String(raw || "").replace(/\s/g, "").toUpperCase();
  if (!iban) return { ok: false, empty: true, msg: "" };
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban)) return { ok: false, msg: "Formato non valido: deve iniziare con il codice paese (es. IT) e contenere solo lettere e numeri" };
  const cc = iban.slice(0, 2);
  if (LEN[cc] && iban.length !== LEN[cc]) return { ok: false, msg: `Lunghezza errata: un IBAN ${cc} ha ${LEN[cc]} caratteri, qui ne hai ${iban.length}` };
  if (cc === "IT" && !/^IT\d{2}[A-Z]\d{10}[A-Z0-9]{12}$/.test(iban)) return { ok: false, msg: "Struttura non valida: dopo IT e le 2 cifre servono 1 lettera (CIN), ABI e CAB di 5 cifre e 12 caratteri di conto" };
  if (!mod97(iban)) return { ok: false, msg: "IBAN non corretto: le cifre di controllo non corrispondono. Probabile errore di battitura" };
  if (cc === "IT" && !cinOk(iban.slice(4))) return { ok: false, msg: "IBAN non corretto: il CIN (la lettera dopo le cifre di controllo) non corrisponde a ABI, CAB e conto" };
  if (cc !== "IT") return { ok: true, msg: `IBAN valido (${cc})` };
  const abi = iban.slice(5, 10), cab = iban.slice(10, 15);
  return { ok: true, abi, cab, bank: BANKS[abi], msg: `IBAN valido${BANKS[abi] ? ` · ${BANKS[abi]}` : ""} · ABI ${abi} · CAB ${cab}` };
}
